import {useFormik} from 'formik';
import {useSchemes} from '../../../shared/lib/validation';
import {useAuth} from '../../../entities/auth/hooks/useAuth';
import {getSessionItem} from '../../../shared/lib';
import { useNavigate } from 'react-router';
import { useQueryClient } from '@tanstack/react-query';

export const usePasswordForm = () => {
  const {passwordSchema} = useSchemes();
  const {loginWithPassword, errorMessage} = useAuth();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const flowId = getSessionItem('auth_flow_id');
  const csrfToken = getSessionItem('auth_csrf_token');
  const identifier = getSessionItem('auth_identifier');

  const onSubmit = async ({password}: {password: string}) => {
    if (!flowId || !identifier || !csrfToken) {
      return;
    }

    try {
      await loginWithPassword({
        identifier,
        password,
        flowId,
        csrfToken,
      });
      await queryClient.refetchQueries({ queryKey: ['session'], exact: true });
      navigate('/', { replace: true });
    } catch (error) {
      console.error('Login or session refetch failed:', error);
    }
  };

  const formik = useFormik({
    initialValues: {
      password: '',
    },
    validationSchema: passwordSchema,
    onSubmit,
  });

  return {
    ...formik,
    errorMessage,
  };
};
